import AddStudyPersonnel from './AddStudyPersonnel';

export default AddStudyPersonnel;
